import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchSelectedRisk } from "../../redux/actions/risksActionCreators";
import Typography from "@mui/material/Typography";
import { fetchAllAssets } from "../../redux/actions/assetsActionCreators";
import { fetchAllWeaknesses } from "../../redux/actions/weaknessesActionCreators";
import AddDetails from "./AddDetails";
import { translate } from "../../utils/utils";
import { useMediaQuery } from "@mui/material";
import AccordionRiskDetails from "../../components/AccordionRiskDetails";
import { Button } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import GlobalInformationCard from "../../components/useCase/GlobalInformationsCard";
import moment from "moment";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", mt: !isMobile ? 7 : 3 }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const RiskDetails = () => {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const [searchAsset, setSearchAsset] = useState(null);
  const [searchWeakness, setSearchWeakness] = useState(null);
  const [pageAsset, setPageAsset] = useState(1);
  const [pageWeakness, setPageWeakness] = useState(1);
  const params = useParams();
  const dispatch = useDispatch();
  const id_owner = localStorage.getItem("orgaId");
  const storedUser = localStorage.getItem("user");
  const accountId = JSON.parse(storedUser)?.account_id;
  const accountType = JSON.parse(storedUser)?.account_type;
  const enterprise = JSON.parse(storedUser)?.entreprise;

  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSearchAsset = (value) => {
    setSearchAsset(value);
    setPageAsset(1);
  };

  const handleSearchWeakness = (value) => {
    setSearchWeakness(value);
    setPageWeakness(1);
  };

  const risk = useSelector((state) => state.risks.selected);

  const allWeaknesses = useSelector(
    (state) => state.weaknesses.infiniteWeaknesses
  );
  const totalWeaknessesPages = useSelector(
    (state) => state.weaknesses.totalPages
  );

  const riskWeaknesses = useSelector(
    (state) => state.weaknesses.riskWeaknesses
  );

  const allAssets = useSelector((state) => state.assets.infiniteAssets);
  const totalAssetPages = useSelector((state) => state.assets.totalPages);

  const riskAssets = useSelector((state) => state.assets.riskAssets);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = (riskType) => {
    setOpen(true);
    setType(riskType);
  };

  const headAssets = [
    { align: "left", value: t("name"), width: "45%" },
    { align: "left", value: t("value"), width: "15%" },
    { align: "left", value: "Source", width: "15%" },
  ];

  const headWeaknesses = [
    { align: "left", value: t("name"), width: "45%" },
    { align: "left", value: "Source", width: "15%" },
    { align: "left", value: "Description", width: "15%" },
  ];

  useEffect(() => {
    dispatch(fetchSelectedRisk(params.riskId));
  }, [dispatch, params.riskId]);

  useEffect(() => {
    dispatch(
      fetchAllAssets(accountType, pageAsset, searchAsset, "all", false, true)
    );
  }, [dispatch, searchAsset, pageAsset]);

  useEffect(() => {
    dispatch(
      fetchAllWeaknesses(pageWeakness, searchWeakness, "all", false, true)
    );
  }, [dispatch, searchWeakness, pageWeakness]);

  useEffect(() => {
    if (risk) {
      dispatch(fetchAllAssets(accountType, 1, null, "all", risk?.assets));
    }
  }, [dispatch, risk]);

  useEffect(() => {
    if (risk) {
      dispatch(fetchAllWeaknesses(1, null, "all", risk?.weaknesses));
    }
  }, [dispatch, risk]);

  const handleAssetPage = (pageNum) => {
    setPageAsset(pageNum);
  };

  const handleWeaknessPage = (pageNum) => {
    setPageWeakness(pageNum);
  };

  let newAssets = allAssets.filter((el) => !risk?.assets?.includes(el.id));
  let newWeaknesses = allWeaknesses.filter(
    (el) => !risk?.weaknesses?.includes(el.id)
  );
  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <Box
      sx={{ padding: !isMobile ? "0px 54px" : "0px 15px" }}
      mt={isMobile ? 2 : 6}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <Grid container>
          <Grid item xs={10} align="left">
            <Typography variant="title">{`${
              risk?.[translate("title") || t("not_specified")]
            } `}</Typography>
          </Grid>
          <div
            style={{ display: "flex", width: "100%", justifyContent: "right" }}
          >
            <GlobalInformationCard label="Source" value={risk?.source} />
            <GlobalInformationCard
              label="Date"
              value={moment(risk?.last_update).format("DD-MM-YYYY")}
            />
          </div>
          <Grid item xs={4} sx={{ mt: 4 }}>
            <Typography variant="title3" sx={{ fontSize: "16px" }}>
              Description:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {
              <Typography sx={{ fontSize: "14px", width: "100%" }}>
                {risk?.[translate("description")] || t("not_specified")}
              </Typography>
            }
          </Grid>
        </Grid>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 5 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
        >
          <Tab label={t("assets")} {...a11yProps(0)} />
          <Tab label={t("weaknesses")} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ width: "100%" }}>
        {isMobile && riskAssets ? (
          <>
            {" "}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="button"
                onClick={() => handleOpen("asset")}
                fullWidth
                sx={{
                  height: "35px",
                  width: "100%",
                  fontSize: "13px",
                  mb: "40px",
                }}
              >
                <AddOutlinedIcon sx={{ width: "15px" }} />
                {t("asset")}
              </Button>
            </div>
            <AccordionRiskDetails
              data={riskAssets}
              head={headAssets}
              type="asset"
              riskAsset={
                parseInt(risk?.organization_id) === parseInt(id_owner) ||
                risk?.related_account_id === accountId
              }
              risk={risk}
              handleOpenDetails={handleOpen}
              id_owner={id_owner}
              source={risk?.organization_id}
              enterprise={enterprise}
              accountId={accountId}
              accountType={accountType}
            />
          </>
        ) : (
          <Table
            data={riskAssets}
            head={headAssets}
            type="asset"
            riskAsset={
              parseInt(risk?.organization_id) === parseInt(id_owner) ||
              risk?.related_account_id === accountId
            }
            risk={risk}
            handleOpenDetails={handleOpen}
            id_owner={id_owner}
            source={risk?.organization_id}
            accountId={accountId}
            accountType={accountType}
          />
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {isMobile ? (
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="button"
                onClick={() => handleOpen("weakness")}
                fullWidth
                sx={{
                  height: "35px",
                  width: "100%",
                  fontSize: "13px",
                  mb: "40px",
                }}
              >
                <AddOutlinedIcon sx={{ width: "15px" }} />
                {t("weakness")}
              </Button>
            </div>
            <AccordionRiskDetails
              data={riskWeaknesses}
              head={headWeaknesses}
              type="weakness"
              riskWeakness={
                parseInt(risk?.organization_id) === parseInt(id_owner) ||
                risk?.related_account_id === accountId
              }
              risk={risk}
              handleOpenDetails={handleOpen}
              id_owner={id_owner}
              source={risk?.organization_id}
              enterprise={enterprise}
              accountId={accountId}
              accountType={accountType}
            />
          </>
        ) : (
          <Table
            data={riskWeaknesses}
            head={headWeaknesses}
            type="weakness"
            riskWeakness={
              parseInt(risk?.organization_id) === parseInt(id_owner) ||
              risk?.related_account_id === accountId
            }
            risk={risk}
            handleOpenDetails={handleOpen}
            id_owner={id_owner}
            source={risk?.organization_id}
            accountId={accountId}
            accountType={accountType}
          />
        )}
      </TabPanel>
      <AddDetails
        open={open}
        handleClose={handleClose}
        assets={newAssets}
        risk={risk}
        type={type}
        weaknesses={newWeaknesses}
        accountId={accountId}
        accountType={accountType}
        handleSearchWeakness={handleSearchWeakness}
        handleSearchAsset={handleSearchAsset}
        handleAssetPage={handleAssetPage}
        handleWeaknessPage={handleWeaknessPage}
        pageAsset={pageAsset}
        totalAssetPages={totalAssetPages}
        pageWeakness={pageWeakness}
        totalWeaknessesPages={totalWeaknessesPages}
      />
    </Box>
  );
};

export default RiskDetails;
